export { NgClickOutsideDirective } from "./ng-click-outside.directive";
export { NgClickOutsideModule } from "./ng-click-outside.module";
